import { Component, Input } from '@angular/core';
import { FinancialInfoChartBar } from '../chart-bar/chart-bar.component';

type FinancialCardType = 'amount' | 'percentage' | 'chart';
@Component({
  selector: 'mfp-financial-card',
  templateUrl: './financial-card.component.html',
  styleUrls: ['./financial-card.component.scss']
})
export class FinancialCardComponent {
  @Input() title = '';
  @Input() percentage = 0;
  @Input() amount = 0;
  @Input() currency = '';
  @Input() type: FinancialCardType = 'amount';
  @Input() text = '';
  @Input() bar1: FinancialInfoChartBar = { title: 'bar1', amount: 0, currency: 'MXN', height: 0 };
  @Input() bar2: FinancialInfoChartBar = { title: 'bar2', amount: 0, currency: 'MXN', height: 0 };
  @Input() forceDesktopStyle = false;

  constructor() {}
}
